(function () {
  'use strict';

  var WORKER_URL = 'https://black-star-ce8a.christophe-f2b.workers.dev';
  var MODEL = 'claude-haiku-4-5-20251001';
  var TODAY = new Date().toISOString().split('T')[0];
  var STORAGE_KEY = 'gcr_grille_' + TODAY;

  /* ======================== DONNEES ======================== */

  /* Symboles typographiques purs - aucun emoji - Safari safe */
  var INTENTIONS = [
    { id: 'ancrage',      symbole: '\u25A0', couleur: '#8B6040', geo: 'metatron'      },
    { id: 'protection',   symbole: '\u25C6', couleur: '#4B0082', geo: 'etoile-david'  },
    { id: 'amour-soi',    symbole: '\u2665', couleur: '#C05070', geo: 'fleur-vie'     },
    { id: 'abondance',    symbole: '\u2736', couleur: '#C09020', geo: 'sri-yantra'    },
    { id: 'sommeil',      symbole: '\u25D4', couleur: '#2A3A80', geo: 'triangle'      },
    { id: 'clarte',       symbole: '\u25C7', couleur: '#007890', geo: 'pentagramme'   },
    { id: 'guerison',     symbole: '\u2764', couleur: '#1A7040', geo: 'fleur-vie'     },
    { id: 'spiritualite', symbole: '\u2605', couleur: '#5A1A9A', geo: 'metatron'      },
    { id: 'creativite',   symbole: '\u25B2', couleur: '#C04A20', geo: 'pentagramme'   },
    { id: 'equilibre',    symbole: '\u2618', couleur: '#907040', geo: 'sri-yantra'    }
  ];

  /* Labels avec accents pour l'affichage */
  var LABELS = {
    'ancrage':      'Ancrage & Stabilit\u00e9',
    'protection':   'Protection',
    'amour-soi':    'Amour de soi',
    'abondance':    'Abondance',
    'sommeil':      'Sommeil & Apaisement',
    'clarte':       'Clart\u00e9 mentale',
    'guerison':     'Gu\u00e9rison',
    'spiritualite': 'Connexion spirituelle',
    'creativite':   'Cr\u00e9ativit\u00e9',
    'equilibre':    '\u00c9quilibre & Harmonie'
  };

  var CRISTAUX = {
    amethyste:    { nom: 'Am\u00e9thyste',         couleur: '#9B59B6', forme: 'hexagone' },
    quartz_rose:  { nom: 'Quartz rose',             couleur: '#F4A0B8', forme: 'cercle'   },
    quartz_clair: { nom: 'Quartz clair',            couleur: '#B8D8E8', forme: 'etoile'   },
    obsidienne:   { nom: 'Obsidienne noire',        couleur: '#2C2830', forme: 'losange'  },
    pierre_lave:  { nom: 'Pierre de lave',          couleur: '#5A3C38', forme: 'cercle'   },
    citrine:      { nom: 'Citrine',                 couleur: '#E8B830', forme: 'hexagone' },
    labradorite:  { nom: 'Labradorite',             couleur: '#4A6888', forme: 'losange'  },
    lapis:        { nom: 'Lapis-lazuli',            couleur: '#2040A0', forme: 'hexagone' },
    malachite:    { nom: 'Malachite',               couleur: '#1A7A48', forme: 'cercle'   },
    pyrite:       { nom: 'Pyrite',                  couleur: '#C8A820', forme: 'etoile'   },
    selenite:     { nom: 'S\u00e9l\u00e9nite',     couleur: '#E0DDD4', forme: 'goutte'   },
    oeil_tigre:   { nom: '\u0152il de tigre',       couleur: '#A87010', forme: 'losange'  },
    fluorite:     { nom: 'Fluorite',                couleur: '#48B8A0', forme: 'hexagone' },
    pierre_lune:  { nom: 'Pierre de lune',          couleur: '#C0B8CC', forme: 'cercle'   },
    hematite:     { nom: 'H\u00e9matite',           couleur: '#887878', forme: 'losange'  },
    aventurine:   { nom: 'Aventurine',              couleur: '#409840', forme: 'cercle'   },
    turquoise:    { nom: 'Turquoise',               couleur: '#28B8A8', forme: 'etoile'   },
    sodalite:     { nom: 'Sodalite',                couleur: '#203878', forme: 'hexagone' },
    cornaline:    { nom: 'Cornaline',               couleur: '#D04820', forme: 'goutte'   },
    aigue_marine: { nom: 'Aigue-marine',            couleur: '#58C0A8', forme: 'hexagone' },
    jaspe_rouge:  { nom: 'Jaspe rouge',             couleur: '#A02020', forme: 'cercle'   },
    kunzite:      { nom: 'Kunzite',                 couleur: '#F090A8', forme: 'etoile'   },
    tanzanite:    { nom: 'Tanzanite',               couleur: '#583890', forme: 'hexagone' },
    chrysocolle:  { nom: 'Chrysocolle',             couleur: '#189090', forme: 'goutte'   },
    rhodonite:    { nom: 'Rhodonite',               couleur: '#B05070', forme: 'cercle'   }
  };

  var CRISTAUX_IDS = Object.keys(CRISTAUX);

  function sanitizeCristalId(id) {
    return (id && CRISTAUX[id]) ? id : 'quartz_clair';
  }

  var GEOMETRIES = {
    'fleur-vie': {
      nom: 'Fleur de Vie',
      comptes: { cheminement: 6, amplification: 6 },
      nodes: {
        centre:       [250, 250],
        cheminement:  [[340,250],[295,172],[205,172],[160,250],[205,328],[295,328]],
        amplification:[[400,250],[325,116],[175,116],[100,250],[175,384],[325,384]]
      }
    },
    'metatron': {
      nom: 'Cube de M\u00e9tatron',
      comptes: { cheminement: 6, amplification: 6 },
      nodes: {
        centre:       [250, 250],
        cheminement:  [[335,250],[292,177],[208,177],[165,250],[208,323],[292,323]],
        amplification:[[405,250],[328,115],[172,115],[95,250],[172,385],[328,385]]
      }
    },
    'etoile-david': {
      nom: '\u00c9toile de David',
      comptes: { cheminement: 6, amplification: 6 },
      nodes: {
        centre:       [250, 250],
        cheminement:  [[250,165],[323,207],[323,293],[250,335],[177,293],[177,207]],
        amplification:[[250,90],[390,170],[390,330],[250,410],[110,330],[110,170]]
      }
    },
    'sri-yantra': {
      nom: 'Sri Yantra',
      comptes: { cheminement: 4, amplification: 8 },
      nodes: {
        centre:       [250, 250],
        cheminement:  [[250,165],[335,250],[250,335],[165,250]],
        amplification:[[250,95],[356,144],[405,250],[356,356],[250,405],[144,356],[95,250],[144,144]]
      }
    },
    'triangle': {
      nom: 'Triangle sacr\u00e9',
      comptes: { cheminement: 3, amplification: 6 },
      nodes: {
        centre:       [250, 250],
        cheminement:  [[250,163],[328,295],[172,295]],
        amplification:[[250,88],[390,170],[390,330],[250,412],[110,330],[110,170]]
      }
    },
    'pentagramme': {
      nom: 'Pentagramme sacr\u00e9',
      comptes: { cheminement: 5, amplification: 5 },
      nodes: {
        centre:       [250, 250],
        cheminement:  [[287,199],[310,270],[250,313],[190,270],[213,199]],
        amplification:[[250,85],[407,199],[347,383],[153,383],[93,199]]
      }
    }
  };

  /* ======================== STATE ======================== */

  var state = {
    step: 1,
    intention: null,
    dob: null,
    signe: null,
    cheminVie: null,
    grille: null,
    loading: false,
    error: null,
    accordionOpen: {},
    pourQui: 'moi',
    nomDestinataire: ''
  };

  var saved = null;
  try { saved = localStorage.getItem(STORAGE_KEY); } catch(e) {}
  if (saved) {
    try {
      var parsed = JSON.parse(saved);
      state.intention  = parsed.intention  || null;
      state.signe      = parsed.signe      || null;
      state.cheminVie  = parsed.cheminVie  || null;
      state.grille     = parsed.grille     || null;
      state.dob        = parsed.dob        || null;
      state.pourQui    = parsed.pourQui    || 'moi';
      state.nomDestinataire = parsed.nomDestinataire || '';
      state.step       = state.grille ? 4 : 1;
    } catch(e) {}
  }

  /* ======================== DOM ======================== */

  var rootEl = document.getElementById('gcr-root');
  var shadow = rootEl.attachShadow({ mode: 'open' });

  /* ======================== UTILS ======================== */

  function getSigneAstro(day, month) {
    var tr = [
      [1,1,'Capricorne'],[20,1,'Verseau'],[19,2,'Poissons'],
      [21,3,'B\u00e9lier'],[20,4,'Taureau'],[21,5,'G\u00e9meaux'],
      [21,6,'Cancer'],[23,7,'Lion'],[23,8,'Vierge'],
      [23,9,'Balance'],[23,10,'Scorpion'],[22,11,'Sagittaire'],
      [22,12,'Capricorne']
    ];
    var signe = 'Capricorne';
    for (var i = 0; i < tr.length; i++) {
      if (month > tr[i][1] || (month === tr[i][1] && day >= tr[i][0])) {
        signe = tr[i][2];
      } else { break; }
    }
    return signe;
  }

  function getCheminVie(day, month, year) {
    var digits = ('' + day + month + year).split('').map(Number);
    var sum = digits.reduce(function(a, b) { return a + b; }, 0);
    while (sum > 9 && sum !== 11 && sum !== 22 && sum !== 33) {
      sum = ('' + sum).split('').map(Number).reduce(function(a, b) { return a + b; }, 0);
    }
    return sum;
  }

  function getPhaseLunaire() {
    var ref = new Date('2025-01-29').getTime();
    var cycle = 29.53 * 86400000;
    var elapsed = ((Date.now() - ref) % cycle + cycle) % cycle;
    var f = elapsed / cycle;
    if (f < 0.0625) return 'Nouvelle Lune';
    if (f < 0.1875) return 'Premier croissant';
    if (f < 0.3125) return 'Premier quartier';
    if (f < 0.4375) return 'Lune gibbeuse croissante';
    if (f < 0.5625) return 'Pleine Lune';
    if (f < 0.6875) return 'Lune gibbeuse d\u00e9croissante';
    if (f < 0.8125) return 'Dernier quartier';
    return 'Dernier croissant';
  }

  function scrollToTool() {
    var rect = rootEl.getBoundingClientRect();
    window.scrollTo({ top: rect.top + window.pageYOffset - 20, behavior: 'smooth' });
  }

  function rad(deg) { return deg * Math.PI / 180; }
  function fx(v) { return parseFloat(v.toFixed(1)); }

  /* ======================== SVG HELPERS ======================== */

  function hexPoints(cx, cy, r) {
    var pts = [];
    for (var i = 0; i < 6; i++) {
      var a = rad(i * 60 - 30);
      pts.push(fx(cx + r * Math.cos(a)) + ',' + fx(cy + r * Math.sin(a)));
    }
    return pts.join(' ');
  }

  function starPoints(cx, cy, r) {
    var pts = [];
    for (var i = 0; i < 12; i++) {
      var a = rad(i * 30 - 90);
      var rr = i % 2 === 0 ? r : r * 0.48;
      pts.push(fx(cx + rr * Math.cos(a)) + ',' + fx(cy + rr * Math.sin(a)));
    }
    return pts.join(' ');
  }

  function goutte(cx, cy, r) {
    return 'M ' + cx + ',' + (cy - r) +
      ' C ' + fx(cx + r * 0.75) + ',' + fx(cy - r * 0.4) +
      ' ' + fx(cx + r * 0.75) + ',' + fx(cy + r * 0.2) +
      ' ' + cx + ',' + fx(cy + r * 0.55) +
      ' C ' + fx(cx - r * 0.75) + ',' + fx(cy + r * 0.2) +
      ' ' + fx(cx - r * 0.75) + ',' + fx(cy - r * 0.4) +
      ' ' + cx + ',' + (cy - r) + ' Z';
  }

  function cristalShape(cx, cy, r, forme, couleur) {
    var fill = 'fill="' + couleur + '"';
    var stroke = 'stroke="#ffffffaa" stroke-width="1.5"';
    if (forme === 'cercle') {
      return '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" ' + fill + ' ' + stroke + '/>';
    } else if (forme === 'hexagone') {
      return '<polygon points="' + hexPoints(cx, cy, r) + '" ' + fill + ' ' + stroke + '/>';
    } else if (forme === 'losange') {
      var dx = fx(r * 0.65);
      return '<polygon points="' + cx + ',' + (cy - r) + ' ' + (cx + dx) + ',' + cy + ' ' + cx + ',' + (cy + r) + ' ' + (cx - dx) + ',' + cy + '" ' + fill + ' ' + stroke + '/>';
    } else if (forme === 'etoile') {
      return '<polygon points="' + starPoints(cx, cy, r) + '" ' + fill + ' stroke="#ffffffaa" stroke-width="1"/>';
    } else if (forme === 'goutte') {
      return '<path d="' + goutte(cx, cy, r) + '" ' + fill + ' ' + stroke + '/>';
    }
    return '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" ' + fill + ' ' + stroke + '/>';
  }

  function geoBg(type) {
    var cx = 250, cy = 250;
    var gs = 'stroke="#d4af37" fill="none"';
    var svg = '';
    /* Etoiles de fond */
    var stars = [[80,60],[420,90],[60,380],[450,400],[150,180],[370,320],[200,430],[330,80],[110,290],[400,200]];
    stars.forEach(function(s) {
      svg += '<circle cx="'+s[0]+'" cy="'+s[1]+'" r="1.4" fill="#d4af37" fill-opacity="0.6"/>';
    });
    if (type === 'fleur-vie') {
      svg += '<circle cx="250" cy="250" r="200" ' + gs + ' stroke-opacity="0.35" stroke-width="1.2"/>';
      svg += '<circle cx="250" cy="250" r="90" ' + gs + ' stroke-opacity="0.75" stroke-width="1.3"/>';
      for (var i = 0; i < 6; i++) {
        var a = rad(i * 60);
        svg += '<circle cx="' + fx(cx + 90 * Math.cos(a)) + '" cy="' + fx(cy - 90 * Math.sin(a)) + '" r="90" ' + gs + ' stroke-opacity="0.55" stroke-width="1"/>';
      }
    } else if (type === 'metatron') {
      svg += '<circle cx="250" cy="250" r="200" ' + gs + ' stroke-opacity="0.35" stroke-width="1.2"/>';
      svg += '<circle cx="250" cy="250" r="87" ' + gs + ' stroke-opacity="0.7" stroke-width="1.2"/>';
      for (var j = 0; j < 6; j++) {
        var aj = rad(j * 60);
        svg += '<circle cx="' + fx(cx + 87 * Math.cos(aj)) + '" cy="' + fx(cy - 87 * Math.sin(aj)) + '" r="87" ' + gs + ' stroke-opacity="0.45" stroke-width="1"/>';
      }
      var t1 = [90,210,330].map(function(ang) { return fx(cx+165*Math.cos(rad(ang)))+','+fx(cy-165*Math.sin(rad(ang))); }).join(' ');
      var t2 = [270,30,150].map(function(ang) { return fx(cx+165*Math.cos(rad(ang)))+','+fx(cy-165*Math.sin(rad(ang))); }).join(' ');
      svg += '<polygon points="' + t1 + '" ' + gs + ' stroke-opacity="0.8" stroke-width="1.5"/>';
      svg += '<polygon points="' + t2 + '" ' + gs + ' stroke-opacity="0.8" stroke-width="1.5"/>';
    } else if (type === 'etoile-david') {
      svg += '<circle cx="250" cy="250" r="188" ' + gs + ' stroke-opacity="0.4" stroke-width="1.2"/>';
      var ed1 = [90,210,330].map(function(ang) { return fx(cx+162*Math.cos(rad(ang)))+','+fx(cy-162*Math.sin(rad(ang))); }).join(' ');
      var ed2 = [270,30,150].map(function(ang) { return fx(cx+162*Math.cos(rad(ang)))+','+fx(cy-162*Math.sin(rad(ang))); }).join(' ');
      svg += '<polygon points="' + ed1 + '" ' + gs + ' stroke-opacity="0.85" stroke-width="1.8"/>';
      svg += '<polygon points="' + ed2 + '" ' + gs + ' stroke-opacity="0.85" stroke-width="1.8"/>';
    } else if (type === 'sri-yantra') {
      svg += '<circle cx="250" cy="250" r="188" ' + gs + ' stroke-opacity="0.4" stroke-width="1.2"/>';
      [158,118,82,48].forEach(function(rr, idx) {
        var angs = idx % 2 === 0 ? [90,210,330] : [270,30,150];
        var pts = angs.map(function(ang) { return fx(cx+rr*Math.cos(rad(ang)))+','+fx(cy-rr*Math.sin(rad(ang))); }).join(' ');
        svg += '<polygon points="' + pts + '" ' + gs + ' stroke-opacity="0.75" stroke-width="1.4"/>';
      });
    } else if (type === 'triangle') {
      svg += '<circle cx="250" cy="250" r="188" ' + gs + ' stroke-opacity="0.4" stroke-width="1.2"/>';
      svg += '<circle cx="250" cy="250" r="92" ' + gs + ' stroke-opacity="0.55" stroke-width="1"/>';
      var tp1 = [90,210,330].map(function(ang) { return fx(cx+168*Math.cos(rad(ang)))+','+fx(cy-168*Math.sin(rad(ang))); }).join(' ');
      var tp2 = [90,210,330].map(function(ang) { return fx(cx+92*Math.cos(rad(ang)))+','+fx(cy-92*Math.sin(rad(ang))); }).join(' ');
      svg += '<polygon points="' + tp1 + '" ' + gs + ' stroke-opacity="0.9" stroke-width="1.8"/>';
      svg += '<polygon points="' + tp2 + '" ' + gs + ' stroke-opacity="0.6" stroke-width="1.2"/>';
    } else if (type === 'pentagramme') {
      /* Cercle extérieur */
      svg += '<circle cx="250" cy="250" r="188" ' + gs + ' stroke-opacity="0.4" stroke-width="1.2"/>';
      /* Cercle intérieur */
      svg += '<circle cx="250" cy="250" r="72" ' + gs + ' stroke-opacity="0.45" stroke-width="1"/>';
      /* 5 sommets extérieurs (r=165, départ -90°) */
      var pTips = [];
      for (var pi = 0; pi < 5; pi++) {
        var pa = rad(-90 + pi * 72);
        pTips.push([fx(cx + 165 * Math.cos(pa)), fx(cy + 165 * Math.sin(pa))]);
      }
      /* Étoile : relier chaque sommet au sommet +2 (pentagramme classique) */
      var starOrder = [0, 2, 4, 1, 3, 0];
      var starPath = starOrder.map(function(i) { return pTips[i][0] + ',' + pTips[i][1]; }).join(' ');
      svg += '<polygon points="' + starPath + '" ' + gs + ' stroke-opacity="0.9" stroke-width="1.8" fill="none"/>';
      /* Pentagon intérieur reliant les intersections */
      var pInner = [];
      for (var qi = 0; qi < 5; qi++) {
        var qa = rad(-54 + qi * 72);
        pInner.push(fx(cx + 63 * Math.cos(qa)) + ',' + fx(cy + 63 * Math.sin(qa)));
      }
      svg += '<polygon points="' + pInner.join(' ') + '" ' + gs + ' stroke-opacity="0.55" stroke-width="1"/>';
    }
    return svg;
  }

  function buildGridSVG(grille, geoKey) {
    var geo = GEOMETRIES[geoKey];
    if (!geo || !grille) return '';
    var nodes = geo.nodes;
    var lines = '';
    var crystals = '';
    nodes.cheminement.forEach(function(pos) {
      lines += '<line x1="250" y1="250" x2="'+pos[0]+'" y2="'+pos[1]+'" stroke="#d4af37" stroke-opacity="0.5" stroke-width="1" stroke-dasharray="4,3"/>';
    });
    nodes.amplification.forEach(function(pos) {
      lines += '<line x1="250" y1="250" x2="'+pos[0]+'" y2="'+pos[1]+'" stroke="#d4af37" stroke-opacity="0.25" stroke-width="0.7" stroke-dasharray="3,4"/>';
    });
    var ampIds = grille.cristaux.amplification || [];
    nodes.amplification.forEach(function(pos, i) {
      var id = sanitizeCristalId(ampIds[i]);
      var c = CRISTAUX[id];
      crystals += '<g class="gcr-crystal" style="animation-delay:'+fx(0.8+i*0.1)+'s">'+cristalShape(pos[0],pos[1],12,c.forme,c.couleur)+'</g>';
    });
    var chemIds = grille.cristaux.cheminement || [];
    nodes.cheminement.forEach(function(pos, i) {
      var id = sanitizeCristalId(chemIds[i]);
      var c = CRISTAUX[id];
      crystals += '<g class="gcr-crystal" style="animation-delay:'+fx(0.3+i*0.12)+'s">'+cristalShape(pos[0],pos[1],16,c.forme,c.couleur)+'</g>';
    });
    var centreId = sanitizeCristalId(grille.cristaux.centre);
    var cc = CRISTAUX[centreId];
    /* Halo lumineux triple autour de la pierre centrale */
    crystals += '<g class="gcr-crystal gcr-crystal-centre" style="animation-delay:0.1s">'+
      '<circle cx="250" cy="250" r="42" fill="'+cc.couleur+'" fill-opacity="0.06" stroke="none"/>'+
      '<circle cx="250" cy="250" r="32" fill="'+cc.couleur+'" fill-opacity="0.1" stroke="none"/>'+
      '<circle cx="250" cy="250" r="24" fill="'+cc.couleur+'" fill-opacity="0.2" stroke="none"/>'+
      cristalShape(250,250,22,cc.forme,cc.couleur)+
      '</g>';
    return '<svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg" class="gcr-svg">'+
      '<defs>'+
        '<radialGradient id="gcr-bg" cx="50%" cy="50%" r="50%">'+
          '<stop offset="0%" stop-color="#1e1838"/>'+
          '<stop offset="60%" stop-color="#100e22"/>'+
          '<stop offset="100%" stop-color="#080612"/>'+
        '</radialGradient>'+
        '<radialGradient id="gcr-glow" cx="50%" cy="50%" r="50%">'+
          '<stop offset="0%" stop-color="#d4af37" stop-opacity="0.08"/>'+
          '<stop offset="100%" stop-color="#d4af37" stop-opacity="0"/>'+
        '</radialGradient>'+
      '</defs>'+
      '<rect width="500" height="500" fill="url(#gcr-bg)" rx="16"/>'+
      '<rect width="500" height="500" fill="url(#gcr-glow)" rx="16"/>'+
      geoBg(geoKey)+lines+crystals+'</svg>';
  }

  function buildLegend(grille) {
    var centreId = sanitizeCristalId(grille.cristaux.centre);
    var cc = CRISTAUX[centreId];
    return '<div class="gcr-legend">'+
      '<div class="gcr-leg-item"><svg width="16" height="16" viewBox="0 0 16 16"><circle cx="8" cy="8" r="7" fill="'+cc.couleur+'"/></svg><span>Pierre centrale\u00a0: <strong>'+cc.nom+'</strong></span></div>'+
      '<div class="gcr-leg-item"><svg width="16" height="16" viewBox="0 0 16 16"><circle cx="8" cy="8" r="6" fill="#8090C0" opacity="0.8"/></svg><span>Cheminement</span></div>'+
      '<div class="gcr-leg-item"><svg width="16" height="16" viewBox="0 0 16 16"><circle cx="8" cy="8" r="4" fill="#B0D0E0" opacity="0.8"/></svg><span>Amplification</span></div>'+
      '</div>';
  }

  /* ======================== LOADING ======================== */

  function buildLoadingSVG(geoKey) {
    var cx = 100, cy = 100;
    var svg = '';
    if (geoKey === 'fleur-vie' || geoKey === 'triangle') {
      svg += '<circle cx="100" cy="100" r="70" fill="none" stroke="#d4af37" stroke-width="1.5" stroke-opacity="0.5" style="stroke-dasharray:440;stroke-dashoffset:440;animation:gcr-draw 2.5s ease forwards"/>';
      svg += '<circle cx="100" cy="100" r="42" fill="none" stroke="#d4af37" stroke-width="1.2" stroke-opacity="0.6" style="stroke-dasharray:264;stroke-dashoffset:264;animation:gcr-draw 2.5s ease forwards;animation-delay:0.4s"/>';
      for (var i = 0; i < 6; i++) {
        var a = rad(i * 60);
        var lx = fx(100 + 42 * Math.cos(a));
        var ly = fx(100 - 42 * Math.sin(a));
        svg += '<circle cx="'+lx+'" cy="'+ly+'" r="42" fill="none" stroke="#d4af37" stroke-width="0.8" stroke-opacity="0.35" style="stroke-dasharray:264;stroke-dashoffset:264;animation:gcr-draw 2.5s ease forwards;animation-delay:'+fx(0.6+i*0.25)+'s"/>';
      }
    } else if (geoKey === 'metatron') {
      svg += '<circle cx="100" cy="100" r="70" fill="none" stroke="#d4af37" stroke-width="1.5" stroke-opacity="0.4" style="stroke-dasharray:440;stroke-dashoffset:440;animation:gcr-draw 2.5s ease forwards"/>';
      var mp1 = [90,210,330].map(function(ang){return fx(100+68*Math.cos(rad(ang)))+','+fx(100-68*Math.sin(rad(ang)));}).join(' ');
      var mp2 = [270,30,150].map(function(ang){return fx(100+68*Math.cos(rad(ang)))+','+fx(100-68*Math.sin(rad(ang)));}).join(' ');
      svg += '<polygon points="'+mp1+'" fill="none" stroke="#d4af37" stroke-width="1.2" stroke-opacity="0.55" style="stroke-dasharray:360;stroke-dashoffset:360;animation:gcr-draw 2s ease forwards;animation-delay:0.3s"/>';
      svg += '<polygon points="'+mp2+'" fill="none" stroke="#d4af37" stroke-width="1.2" stroke-opacity="0.55" style="stroke-dasharray:360;stroke-dashoffset:360;animation:gcr-draw 2s ease forwards;animation-delay:0.7s"/>';
    } else if (geoKey === 'etoile-david') {
      svg += '<circle cx="100" cy="100" r="70" fill="none" stroke="#d4af37" stroke-width="1.2" stroke-opacity="0.3" style="stroke-dasharray:440;stroke-dashoffset:440;animation:gcr-draw 2.5s ease forwards"/>';
      var e1 = [90,210,330].map(function(ang){return fx(100+67*Math.cos(rad(ang)))+','+fx(100-67*Math.sin(rad(ang)));}).join(' ');
      var e2 = [270,30,150].map(function(ang){return fx(100+67*Math.cos(rad(ang)))+','+fx(100-67*Math.sin(rad(ang)));}).join(' ');
      svg += '<polygon points="'+e1+'" fill="none" stroke="#d4af37" stroke-width="1.5" stroke-opacity="0.6" style="stroke-dasharray:360;stroke-dashoffset:360;animation:gcr-draw 2s ease forwards;animation-delay:0.3s"/>';
      svg += '<polygon points="'+e2+'" fill="none" stroke="#d4af37" stroke-width="1.5" stroke-opacity="0.6" style="stroke-dasharray:360;stroke-dashoffset:360;animation:gcr-draw 2s ease forwards;animation-delay:0.9s"/>';
    } else if (geoKey === 'pentagramme') {
      var ldTips = [];
      for (var lpi = 0; lpi < 5; lpi++) {
        var lpa = rad(-90 + lpi * 72);
        ldTips.push([fx(100 + 66 * Math.cos(lpa)), fx(100 + 66 * Math.sin(lpa))]);
      }
      svg += '<circle cx="100" cy="100" r="75" fill="none" stroke="#d4af37" stroke-width="1.2" stroke-opacity="0.3" style="stroke-dasharray:472;stroke-dashoffset:472;animation:gcr-draw 2s ease forwards"/>';
      var ldPath = [0,2,4,1,3,0].map(function(i){return ldTips[i][0]+','+ldTips[i][1];}).join(' ');
      svg += '<polygon points="'+ldPath+'" fill="none" stroke="#d4af37" stroke-width="1.5" stroke-opacity="0.85" style="stroke-dasharray:640;stroke-dashoffset:640;animation:gcr-draw 3s ease forwards;animation-delay:0.2s"/>';
      var ldInner = [];
      for (var lqi = 0; lqi < 5; lqi++) {
        var lqa = rad(-54 + lqi * 72);
        ldInner.push(fx(100+25*Math.cos(lqa))+','+fx(100+25*Math.sin(lqa)));
      }
      svg += '<polygon points="'+ldInner.join(' ')+'" fill="none" stroke="#d4af37" stroke-width="1" stroke-opacity="0.5" style="stroke-dasharray:200;stroke-dashoffset:200;animation:gcr-draw 2s ease forwards;animation-delay:1s"/>';
    } else {
      [68,50,34,20].forEach(function(rr, idx) {
        var angs = idx % 2 === 0 ? [90,210,330] : [270,30,150];
        var pts = angs.map(function(ang){return fx(100+rr*Math.cos(rad(ang)))+','+fx(100-rr*Math.sin(rad(ang)));}).join(' ');
        svg += '<polygon points="'+pts+'" fill="none" stroke="#d4af37" stroke-width="1.2" stroke-opacity="0.55" style="stroke-dasharray:320;stroke-dashoffset:320;animation:gcr-draw 1.8s ease forwards;animation-delay:'+fx(idx*0.35)+'s"/>';
      });
    }
    svg += '<circle cx="100" cy="100" r="4" fill="#d4af37" opacity="0" style="animation:gcr-dot-in 0.8s ease forwards;animation-delay:1.8s"/>';
    svg += '<circle cx="100" cy="100" r="8" fill="none" stroke="#d4af37" stroke-width="0.8" opacity="0" style="animation:gcr-dot-in 0.8s ease forwards;animation-delay:2s"/>';
    return svg;
  }

  function renderLoading() {
    var geoKey = (state.intention && state.intention.geo) || 'fleur-vie';
    var phrases = [
      'La g\u00e9om\u00e9trie se d\u00e9ploie\u2026',
      'Les cristaux \u00e9th\u00e9riques se positionnent\u2026',
      'La grille s\u2019aligne sur votre \u00e9nergie\u2026'
    ];
    var phrasesHTML = phrases.map(function(p, i) {
      return '<span class="gcr-ld-phrase" style="animation-delay:'+fx(i*1.8)+'s">'+p+'</span>';
    }).join('');
    return '<div class="gcr-loading">'+
      '<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" class="gcr-ld-svg">'+buildLoadingSVG(geoKey)+'</svg>'+
      '<div class="gcr-ld-phrases">'+phrasesHTML+'</div>'+
      '</div>';
  }

  /* ======================== PROMPT ======================== */

  function buildPrompt() {
    var intention = state.intention;
    var geo = GEOMETRIES[intention.geo];
    var cristalListe = CRISTAUX_IDS.map(function(id){return '- '+id+' : '+CRISTAUX[id].nom;}).join('\n');
    var destinataire = state.pourQui === 'autre'
      ? (state.nomDestinataire ? state.nomDestinataire : 'un proche')
      : 'la personne elle-m\u00eame';
    var rituelInstructions = state.pourQui === 'autre'
      ? ('- rituel : un rituel de transmission en 3 \u00e9tapes courtes (max 2 minutes). '
        + 'Cette grille est g\u00e9n\u00e9r\u00e9e PAR quelqu\'un POUR ' + destinataire + ' qui ne sera peut-\u00eatre pas pr\u00e9sent(e). '
        + '\u00c9tape 1 = geste que fait la personne qui transmet (tenir l\'image de la grille, poser l\'intention). '
        + '\u00c9tape 2 = visualisation d\'envoi \u00e9nerg\u00e9tique vers ' + destinataire + ' (imaginer la grille se poser sur son champ). '
        + '\u00c9tape 3 = formule d\'ancrage \u00e0 prononcer \u00e0 voix haute ou int\u00e9rieurement pour sceller la transmission. '
        + 'Vouvoiement pour la personne qui transmet. Aucun markdown.')
      : ('- rituel : un rituel d\'ancrage en 3 \u00e9tapes tr\u00e8s concr\u00e8tes (max 2 minutes au total). '
        + 'Chaque \u00e9tape commence par un verbe d\'action. '
        + '\u00c9tape 1 = geste physique (mains, posture, souffle). '
        + '\u00c9tape 2 = visualisation de la grille entrant dans le corps. '
        + '\u00c9tape 3 = affirmation courte \u00e0 prononcer ou ressentir int\u00e9rieurement. '
        + 'Vouvoiement. Aucun markdown.');
    return 'Tu es un ma\u00eetre en lith\u00e9rapie et g\u00e9om\u00e9trie sacr\u00e9e. G\u00e9n\u00e8re une grille cristalline \u00e9th\u00e9rique personnalis\u00e9e.\n\n'+
      'CONTEXTE :\n'+
      '- Destinataire : '+destinataire+'\n'+
      '- Intention : '+LABELS[intention.id]+'\n'+
      '- Signe astrologique : '+state.signe+'\n'+
      '- Chemin de vie num\u00e9rologique : '+state.cheminVie+'\n'+
      '- Phase lunaire : '+getPhaseLunaire()+'\n'+
      '- G\u00e9om\u00e9trie sacr\u00e9e : '+geo.nom+'\n\n'+
      'CRISTAUX DISPONIBLES (UNIQUEMENT ces identifiants, aucun autre) :\n'+
      cristalListe+'\n\n'+
      'R\u00c8GLES ABSOLUES :\n'+
      '- centre : 1 cristal puissant en r\u00e9sonance avec l\'intention ET le signe\n'+
      '- cheminement : exactement '+geo.comptes.cheminement+' cristaux distincts (pas de r\u00e9p\u00e9tition entre eux)\n'+
      '- amplification : exactement '+geo.comptes.amplification+' cristaux (quartz_clair autoris\u00e9 plusieurs fois)\n'+
      '- Utilise UNIQUEMENT les identifiants de la liste - aucun autre n\'est valide\n'+
      '- Varie selon le signe et la phase lunaire pour que chaque grille soit unique\n'+
      '- Fran\u00e7ais, vouvoiement (vous/votre), z\u00e9ro markdown (pas de #, **, *, -)\n'+
      '- Po\u00e9tique et pr\u00e9cis, sans clich\u00e9s, jamais "ch\u00e8re \u00e2me" ni "guidance"\n'+
      '- message_intention : 3 phrases en vouvoiement s\'adressant directement \u00e0 la personne\n'+
      rituelInstructions + '\n\n'+
      'R\u00e9ponds UNIQUEMENT en JSON valide sans texte avant ni apr\u00e8s :\n'+
      '{"nom_grille":"...","cristaux":{"centre":"id","cheminement":["id1","id2"],"amplification":["id1","id2"]},"explication_centre":"...","explication_cheminement":"...","explication_amplification":"...","activation":"...","message_intention":"...","rituel":{"etape1":"...","etape2":"...","etape3":"..."}}';
  }

  /* ======================== API ======================== */

  function generateGrille() {
    state.loading = true;
    state.error = null;
    renderView();
    fetch(WORKER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ model: MODEL, max_tokens: 1400, messages: [{ role: 'user', content: buildPrompt() }] })
    })
    .then(function(res) { if (!res.ok) throw new Error('Erreur '+res.status); return res.json(); })
    .then(function(data) {
      var rawText = (data.content && data.content[0] && data.content[0].text) ? data.content[0].text : '';
      var match = rawText.match(/\{[\s\S]*\}/);
      if (!match) throw new Error('JSON invalide');
      var grille = JSON.parse(match[0]);
      var geo = GEOMETRIES[state.intention.geo];

      grille.cristaux.centre = sanitizeCristalId(grille.cristaux.centre);

      if (!Array.isArray(grille.cristaux.cheminement)) grille.cristaux.cheminement = [];
      grille.cristaux.cheminement = grille.cristaux.cheminement.map(sanitizeCristalId);
      while (grille.cristaux.cheminement.length < geo.comptes.cheminement) grille.cristaux.cheminement.push('quartz_clair');
      grille.cristaux.cheminement = grille.cristaux.cheminement.slice(0, geo.comptes.cheminement);

      if (!Array.isArray(grille.cristaux.amplification)) grille.cristaux.amplification = [];
      grille.cristaux.amplification = grille.cristaux.amplification.map(sanitizeCristalId);
      while (grille.cristaux.amplification.length < geo.comptes.amplification) grille.cristaux.amplification.push('quartz_clair');
      grille.cristaux.amplification = grille.cristaux.amplification.slice(0, geo.comptes.amplification);

      state.grille = grille;
      state.loading = false;
      state.step = 4;
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ intention: state.intention, signe: state.signe, cheminVie: state.cheminVie, grille: state.grille, dob: state.dob, pourQui: state.pourQui, nomDestinataire: state.nomDestinataire })); } catch(e) {}
      renderView();
      scrollToTool();
    })
    .catch(function() {
      state.loading = false;
      state.error = 'Une erreur s\u2019est produite lors de la composition de votre grille. Veuillez r\u00e9essayer.';
      state.step = 2;
      renderView();
    });
  }

  /* ======================== CSS ======================== */

  var CSS = '<style>*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}:host{display:block}.gcr-wrap{font-family:Raleway,sans-serif;color:#2a2520;max-width:800px;margin:0 auto;padding:2rem 1rem 4rem}.gcr-header{text-align:center;margin-bottom:1.75rem}.gcr-header h2{font-family:"Cormorant Garamond",serif;font-size:clamp(1.7rem,4vw,2.3rem);font-weight:300;color:#1a1510;line-height:1.25;margin-bottom:.5rem;letter-spacing:-.01em}.gcr-header h2 em{font-style:italic;color:#8B6520;font-weight:400}.gcr-header p{font-size:.87rem;color:#5a4a30;font-weight:300;letter-spacing:.04em;line-height:1.6}.gcr-intro{background:linear-gradient(160deg,#fffef8,#f5edd8);border:1px solid #e8d9a0;border-radius:14px;padding:1.5rem 1.75rem;margin-bottom:1.75rem;text-align:center;position:relative;overflow:hidden}.gcr-intro p{font-family:"Cormorant Garamond",serif;font-style:italic;font-size:1.05rem;color:#4a380f;line-height:1.85;margin-bottom:.8rem}.gcr-intro ul{list-style:none;display:flex;flex-wrap:wrap;justify-content:center;gap:.4rem;padding:0}.gcr-intro li{display:inline-flex;align-items:center;gap:.35rem;font-size:.76rem;color:#6a5020;font-family:Raleway,sans-serif;background:#fffef5;border:1px solid #ddd0a0;border-radius:20px;padding:.28rem .75rem}.gcr-intro li::before{content:"✶";color:#d4af37;font-size:.6rem}.gcr-intro strong{font-weight:600;color:#4a380f}.gcr-intentions{display:grid;grid-template-columns:repeat(auto-fill,minmax(138px,1fr));gap:.65rem;margin-bottom:1.5rem}.gcr-tile{background:#fdfbf7;border:1px solid #e0d8c0;border-radius:12px;padding:1rem .7rem .85rem;cursor:pointer;text-align:center;transition:all .25s cubic-bezier(.34,1.56,.64,1);display:flex;flex-direction:column;align-items:center;gap:.45rem;font-family:Raleway,sans-serif;-webkit-appearance:none;appearance:none;position:relative;overflow:hidden;border-top-width:3px}.gcr-tile:hover{transform:translateY(-3px) scale(1.02);box-shadow:0 8px 24px rgba(0,0,0,.1)}.gcr-tile.selected{box-shadow:0 6px 24px rgba(212,175,55,.3);background:linear-gradient(160deg,#fffef0,#fdf5d5)}.gcr-symbole{font-size:1.4rem;line-height:1}.gcr-label{font-size:.74rem;font-weight:600;color:#2a2520;letter-spacing:.03em;line-height:1.35;text-transform:uppercase}.gcr-form{max-width:380px;margin:0 auto}.gcr-flabel{display:block;font-size:.75rem;font-weight:500;color:#5a4a30;margin-bottom:.4rem;letter-spacing:.05em;text-transform:uppercase}.gcr-input{width:100%;padding:.7rem 1rem;border:1.5px solid #cdc0a0;border-radius:8px;font-family:Raleway,sans-serif;font-size:1rem;color:#2a2520;background:#fdfbf7;outline:none;transition:border-color .2s;-webkit-appearance:none;appearance:none}.gcr-input:focus{border-color:#d4af37}.gcr-btn{display:inline-flex;align-items:center;gap:.5rem;padding:.72rem 1.8rem;border:1.5px solid #d4af37;border-radius:8px;background:#fdfbf7;color:#6b5010;font-family:Raleway,sans-serif;font-size:.87rem;font-weight:500;letter-spacing:.04em;cursor:pointer;transition:all .2s;-webkit-appearance:none;appearance:none}.gcr-btn:hover{background:#d4af37;color:#fff}.gcr-btn-primary{background:#d4af37;color:#1a1510;font-weight:600}.gcr-btn-primary:hover{background:#b8952a;color:#fff}.gcr-btn-ghost{background:transparent;border-color:#c0a870;color:#8a6830;font-size:.82rem;padding:.55rem 1.2rem}.gcr-btn-ghost:hover{background:#d4af37;color:#fff;border-color:#d4af37}.gcr-btn-row{display:flex;gap:.75rem;justify-content:center;flex-wrap:wrap;margin-top:1.5rem}.gcr-back{background:none;border:none;color:#8a7050;font-family:Raleway,sans-serif;font-size:.82rem;cursor:pointer;padding:.25rem 0;margin-bottom:1rem;display:inline-flex;align-items:center;gap:.3rem;-webkit-appearance:none;appearance:none}.gcr-back:hover{color:#d4af37}.gcr-error{background:#fff3f3;border:1px solid #f0c0c0;border-radius:8px;padding:.9rem;color:#b03030;font-size:.85rem;text-align:center;margin:.75rem 0}.gcr-toggle-row{display:flex;gap:0;margin-bottom:1.1rem;border:1.5px solid #d4af37;border-radius:8px;overflow:hidden}.gcr-toggle{flex:1;padding:.6rem .5rem;background:transparent;border:none;font-family:Raleway,sans-serif;font-size:.8rem;font-weight:500;color:#8a6830;cursor:pointer;transition:all .2s;-webkit-appearance:none;appearance:none}.gcr-toggle.active{background:#d4af37;color:#1a1510}.gcr-loading{text-align:center;padding:3rem 1rem}.gcr-ld-svg{width:200px;height:200px;margin:0 auto 1.5rem;display:block}@keyframes gcr-draw{to{stroke-dashoffset:0}}@keyframes gcr-dot-in{from{opacity:0}to{opacity:1}}.gcr-ld-phrases{height:1.8rem;position:relative;overflow:hidden}.gcr-ld-phrase{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-family:"Cormorant Garamond",serif;font-style:italic;font-size:1rem;color:#6b5010;opacity:0;animation:gcr-phrase 5.4s ease infinite}@keyframes gcr-phrase{0%,100%{opacity:0;transform:translateY(8px)}8%,28%{opacity:1;transform:translateY(0)}35%{opacity:0;transform:translateY(-6px)}}.gcr-divider{display:flex;align-items:center;gap:1rem;margin:1.75rem 0;color:#c0a060;font-size:1rem}.gcr-divider::before,.gcr-divider::after{content:"";flex:1;height:1px;background:linear-gradient(to right,transparent,#d4af37,transparent)}.gcr-strip{display:flex;justify-content:center;gap:0;flex-wrap:wrap;margin-bottom:1.5rem}.gcr-strip span{display:inline-flex;align-items:center;gap:.4rem;font-size:.77rem;color:#5a4a30;padding:.45rem .9rem;background:#fdfbf7;border:1px solid #e0d0a0;margin:0 -.5px 0 0}.gcr-strip span:first-child{border-radius:8px 0 0 8px}.gcr-strip span:last-child{border-radius:0 8px 8px 0;margin-right:0}.gcr-strip span::before{content:"✶";color:#d4af37;font-size:.6rem}.gcr-grid-section{text-align:center;margin-bottom:1.5rem}.gcr-grid-title{font-family:"Cormorant Garamond",serif;font-style:italic;font-size:clamp(1.5rem,4vw,2rem);font-weight:300;color:#1a1510;margin-bottom:.15rem;letter-spacing:-.01em;line-height:1.2}.gcr-grid-sub{font-size:.68rem;color:#b09060;letter-spacing:.18em;text-transform:uppercase;margin-bottom:1.25rem}.gcr-svg{width:100%;max-width:420px;height:auto;border-radius:16px;box-shadow:0 12px 60px rgba(0,0,0,.5),0 0 40px rgba(212,175,55,.15);display:block;margin:0 auto}.gcr-crystal{animation:gcr-crystal-in .6s ease both;transform-box:fill-box;transform-origin:center}.gcr-crystal-centre{animation:gcr-crystal-in .7s ease both}@keyframes gcr-crystal-in{from{opacity:0;transform:scale(0.2)}to{opacity:1;transform:scale(1)}}.gcr-legend{display:flex;justify-content:center;gap:1.25rem;flex-wrap:wrap;margin:.75rem 0 1.25rem}.gcr-leg-item{display:flex;align-items:center;gap:.35rem;font-size:.75rem;color:#5a4a30}.gcr-leg-item strong{color:#2a2520}.gcr-chips{display:flex;flex-wrap:wrap;gap:.45rem;margin-bottom:1.25rem;justify-content:center}.gcr-chip{display:inline-flex;align-items:center;gap:.4rem;padding:.38rem .85rem;background:#fdfbf7;border:1px solid #ddd0b0;border-radius:20px;font-size:.76rem;color:#2a2520;font-weight:500}.gcr-dot{width:9px;height:9px;border-radius:50%;flex-shrink:0}.gcr-message{position:relative;background:linear-gradient(160deg,#fffef0,#fdf5cc);border:1px solid #d4c060;border-radius:16px;padding:2rem 2rem 1.75rem;margin:1.25rem 0;text-align:center;overflow:hidden}.gcr-message::before{content:"“";position:absolute;top:-.2rem;left:.9rem;font-family:"Cormorant Garamond",serif;font-size:5rem;color:#d4af37;opacity:.2;line-height:1;pointer-events:none}.gcr-message::after{content:"”";position:absolute;bottom:-1.5rem;right:.9rem;font-family:"Cormorant Garamond",serif;font-size:5rem;color:#d4af37;opacity:.2;line-height:1;pointer-events:none}.gcr-message p{font-family:"Cormorant Garamond",serif;font-style:italic;font-size:1.15rem;color:#3a2800;line-height:1.9;position:relative;z-index:1}.gcr-rituel{background:linear-gradient(160deg,#12102a,#1a1535);border:1px solid rgba(212,175,55,.3);border-radius:16px;padding:1.75rem 1.5rem;margin:1.25rem 0;position:relative;overflow:hidden}.gcr-rituel::before{content:"";position:absolute;top:0;left:0;right:0;height:2px;background:linear-gradient(to right,transparent,#d4af37,transparent)}.gcr-rituel-title{font-family:"Cormorant Garamond",serif;font-style:italic;font-size:1rem;color:#d4af37;text-align:center;letter-spacing:.06em;margin-bottom:1.25rem}.gcr-rituel-steps{display:flex;flex-direction:column;gap:.9rem}.gcr-rituel-step{display:flex;gap:.9rem;align-items:flex-start}.gcr-rituel-num{width:28px;height:28px;border-radius:50%;border:1px solid rgba(212,175,55,.5);display:flex;align-items:center;justify-content:center;font-size:.7rem;font-weight:600;color:#d4af37;flex-shrink:0;font-family:Raleway,sans-serif;margin-top:.1rem}.gcr-rituel-text{font-family:"Cormorant Garamond",serif;font-style:italic;font-size:1rem;color:#e8e0d0;line-height:1.7}.gcr-accordions{margin-top:.75rem}.gcr-acc{border-bottom:1px solid #e8dfc8}.gcr-acc-trigger{width:100%;text-align:left;padding:.95rem 0;background:none;border:none;cursor:pointer;display:flex;align-items:center;justify-content:space-between;gap:1rem;font-family:Raleway,sans-serif;-webkit-appearance:none;appearance:none}.gcr-acc-label{font-size:.84rem;font-weight:600;color:#2a2520;letter-spacing:.04em;text-transform:uppercase}.gcr-acc-arrow{font-size:.6rem;color:#d4af37;transition:transform .3s;flex-shrink:0}.gcr-acc-body{display:none;padding:0 0 1.1rem 1rem;border-left:2px solid transparent}.gcr-acc-body.open{display:block;border-left-color:#d4af37}.gcr-acc-body p{font-size:.87rem;line-height:1.85;color:#3a3028}.gcr-poetic{font-family:"Cormorant Garamond",serif;font-style:italic;font-size:1rem;color:#6b5010}.gcr-cta{background:#f5f0e8;border:1px solid #d0c5a8;border-radius:12px;padding:1.2rem 1.4rem;margin-top:.75rem;text-align:center}.gcr-cta p{font-size:.83rem;color:#5a4a30;margin-bottom:.7rem;line-height:1.65}.gcr-cta a{display:inline-block;padding:.55rem 1.5rem;border:1.5px solid #d4af37;border-radius:8px;background:#fdfbf7;color:#6b5010;font-family:Raleway,sans-serif;font-size:.83rem;font-weight:600;text-decoration:none;transition:all .2s}.gcr-cta a:hover{background:#d4af37;color:#fff}.gcr-notice{background:#f0ede5;border-radius:8px;padding:.7rem 1rem;margin-top:1.1rem;text-align:center;font-size:.77rem;color:#6a5838}.gcr-reset-row{display:flex;justify-content:center;gap:.75rem;flex-wrap:wrap;margin-top:1.25rem;padding-top:1rem;border-top:1px solid #e8e0cc}@media(max-width:480px){.gcr-intentions{grid-template-columns:repeat(2,1fr)}.gcr-strip{flex-wrap:wrap}.gcr-strip span{border-radius:6px!important;margin:.2rem}}</style>';


  function printGrille() {
    var grille = state.grille;
    var intention = state.intention;
    if (!grille || !intention) return;
    var geo = GEOMETRIES[intention.geo];
    var svgContent = buildGridSVG(grille, intention.geo);
    var dateStr = new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
    var allIds = [grille.cristaux.centre].concat(grille.cristaux.cheminement || []).concat(grille.cristaux.amplification || []);
    var seen = {}; var uniqueIds = [];
    allIds.forEach(function(id) { if (!seen[id]) { seen[id] = true; uniqueIds.push(id); } });
    var legendRows = uniqueIds.map(function(id) {
      var c = CRISTAUX[id] || {};
      var role = id === grille.cristaux.centre ? 'Pierre centrale'
        : (grille.cristaux.cheminement || []).indexOf(id) >= 0 ? 'Cheminement' : 'Amplification';
      return '<tr><td style="padding:.3rem .5rem"><svg width="12" height="12" viewBox="0 0 12 12"><circle cx="6" cy="6" r="5" fill="' + (c.couleur || '#888') + '"/></svg></td><td style="padding:.3rem .5rem;font-weight:500">' + (c.nom || id) + '</td><td style="padding:.3rem .5rem;color:#888">' + role + '</td></tr>';
    }).join('');
    var html = '<!DOCTYPE html><html lang="fr"><head><meta charset="UTF-8"><title>Grille</title>'
      + '<link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300;1,400&family=Raleway:wght@300;400;500&display=swap" rel="stylesheet">'
      + '<style>*{box-sizing:border-box;margin:0;padding:0}body{font-family:Raleway,sans-serif;color:#2a2520;padding:2rem}h1{font-family:"Cormorant Garamond",serif;font-style:italic;font-size:1.6rem;font-weight:400;text-align:center;margin-bottom:.2rem}.sub{font-size:.72rem;color:#8a7050;letter-spacing:.1em;text-transform:uppercase;text-align:center;margin-bottom:1rem}.div{height:1px;background:linear-gradient(to right,transparent,#d4af37,transparent);margin:1rem 0}.strip{display:flex;justify-content:center;gap:1.5rem;font-size:.77rem;color:#6a5030;margin-bottom:1.2rem;flex-wrap:wrap}.grid{text-align:center;margin-bottom:1.2rem}.grid svg{width:300px;height:300px;border-radius:10px}table{width:100%;border-collapse:collapse;font-size:.8rem;margin-bottom:1.2rem}td{border-bottom:1px solid #f0e8d0;vertical-align:middle}.msg{background:#fffdf0;border:1px solid #e8d880;border-radius:8px;padding:1rem;margin-bottom:1.2rem;text-align:center}.msg p{font-family:"Cormorant Garamond",serif;font-style:italic;font-size:.98rem;color:#4a3010;line-height:1.85}.activ{background:#f5f2ea;border-radius:8px;padding:1rem;margin-bottom:1.5rem}.activ p{font-family:"Cormorant Garamond",serif;font-style:italic;font-size:.93rem;color:#6b5010;line-height:1.85}footer{border-top:1px solid #e0d0a0;padding-top:.8rem;display:flex;justify-content:space-between;font-size:.71rem;color:#a09080}footer strong{color:#d4af37}</style>'
      + '<scr' + 'ipt>window.onload=function(){window.print();}<' + '/script>'
      + '</head><body>'
      + '<h1>' + (grille.nom_grille || 'Grille Cristalline') + '</h1>'
      + '<div class="sub">' + geo.nom + '</div>'
      + '<div class="div"></div>'
      + '<div class="strip"><span>' + state.signe + '</span><span>Chemin : ' + state.cheminVie + '</span><span>' + getPhaseLunaire() + '</span></div>'
      + '<div class="grid">' + svgContent + '</div>'
      + '<table>' + legendRows + '</table>'
      + '<div class="msg"><p>' + (grille.message_intention || '') + '</p></div>'
      + '<div class="activ"><p>' + (grille.activation || '') + '</p></div>'
      + '<footer><span>Genere le ' + dateStr + '</span><strong>unlieudelumiere.com</strong></footer>'
      + '</body></html>';
    var blob = new Blob([html], { type: 'text/html;charset=utf-8' });
    var url = URL.createObjectURL(blob);
    var win = window.open(url, '_blank');
    if (!win) { var a = document.createElement('a'); a.href = url; a.target = '_blank'; a.click(); }
    setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
  }

/* ======================== RENDER ======================== */

  function renderView() {
    var html = '';
    if (state.loading) {
      html = renderLoading();
    } else if (state.step === 4 && state.grille) {
      html = renderStep4();
    } else if (state.step === 2 && state.intention) {
      html = renderStep2();
    } else {
      html = renderStep1();
    }
    shadow.innerHTML = CSS + '<div class="gcr-wrap">' + html + '</div>';
    bindEvents();
  }

  function renderStep1() {
    var tiles = INTENTIONS.map(function(int) {
      var sel = (state.intention && state.intention.id === int.id) ? ' selected' : '';
      return '<button class="gcr-tile'+sel+'" data-intention="'+int.id+'" style="border-top-color:'+int.couleur+'">'+
        '<span class="gcr-symbole" style="color:'+int.couleur+'">'+int.symbole+'</span>'+
        '<span class="gcr-label">'+LABELS[int.id]+'</span>'+
        '</button>';
    }).join('');
    return '<div class="gcr-header">'+
        '<h2>Quelle est votre <em>intention</em> du moment\u00a0?</h2>'+
        '<p>Choisissez l\u2019\u00e9nergie que vous souhaitez cultiver aujourd\u2019hui</p>'+
      '</div>'+
      '<div class="gcr-intro">'+
        '<p>Cet outil compose une grille cristalline \u00e9th\u00e9rique unique,<br>con\u00e7ue selon une intention, un signe astrologique et l\u2019\u00e9nergie du jour.<br>Elle agit dans le plan \u00e9th\u00e9rique d\u00e8s sa r\u00e9v\u00e9lation \u2014 aucun cristal physique n\u2019est requis.<br><strong>Elle peut \u00eatre g\u00e9n\u00e9r\u00e9e pour vous ou pour un proche, un client, un \u00eatre cher.</strong></p>'+
        '<ul>'+
          '<li>Choisissez votre intention</li>'+
          '<li>Entrez la date de naissance</li>'+
          '<li>Recevez la grille personnalis\u00e9e</li>'+
        '</ul>'+
      '</div>'+
      '<div class="gcr-intentions">'+tiles+'</div>';
  }

  function renderStep2() {
    var isMoi = state.pourQui !== 'autre';
    return '<button class="gcr-back" id="gcr-back">\u2190 Modifier l\u2019intention</button>'+
      '<div class="gcr-header">'+
        '<h2>Pour <em>qui</em> est cette grille\u00a0?</h2>'+
        '<p>La date de naissance permet d\u2019affiner les cristaux selon le signe et le chemin de vie</p>'+
      '</div>'+
      '<div class="gcr-form">'+
        '<div class="gcr-toggle-row">'+
          '<button class="gcr-toggle'+(isMoi?' active':'')+'" data-pq="moi">Pour moi</button>'+
          '<button class="gcr-toggle'+(!isMoi?' active':'')+'" data-pq="autre">Pour un proche / un client</button>'+
        '</div>'+
        (!isMoi ? '<div style="margin-bottom:.9rem"><label class="gcr-flabel" for="gcr-nom">Pr\u00e9nom (optionnel)</label><input class="gcr-input" type="text" id="gcr-nom" placeholder="Ex\u00a0: Marie" value="'+state.nomDestinataire+'"></div>' : '')+
        '<label class="gcr-flabel" for="gcr-dob">Date de naissance</label>'+
        '<input class="gcr-input" type="date" id="gcr-dob" max="'+TODAY+'" value="'+(state.dob||'')+'">'+
        (state.error ? '<div class="gcr-error">'+state.error+'</div>' : '')+
        '<div class="gcr-btn-row">'+
          '<button class="gcr-btn gcr-btn-primary" id="gcr-generate">Composer la grille \u2736</button>'+
        '</div>'+
      '</div>';
  }

  function renderStep4() {
    var grille = state.grille;
    var intention = state.intention;
    var geo = GEOMETRIES[intention.geo];

    var strip = '<div class="gcr-strip">'+
      '<span>\u2736 '+LABELS[intention.id]+'</span>'+
      '<span>\u2648 '+state.signe+'</span>'+
      '<span>\u2295 Chemin de vie\u00a0: '+state.cheminVie+'</span>'+
      '<span>\uD83C\uDF19 '+getPhaseLunaire()+'</span>'+
      '</div>';

    var gridHTML = '<div class="gcr-grid-section">'+
      '<div class="gcr-grid-title">'+(grille.nom_grille||'Votre Grille Cristalline')+'</div>'+
      '<div class="gcr-grid-sub">'+geo.nom+'</div>'+
      buildGridSVG(grille, intention.geo)+
      buildLegend(grille)+
      '</div>';

    var allIds = [grille.cristaux.centre].concat(grille.cristaux.cheminement||[]).concat(grille.cristaux.amplification||[]);
    var seen = {}; var uniqueIds = [];
    allIds.forEach(function(id){if(!seen[id]){seen[id]=true;uniqueIds.push(id);}});
    var chips = '<div class="gcr-chips">'+
      uniqueIds.map(function(id){
        var c=CRISTAUX[id]||{};
        return '<div class="gcr-chip"><div class="gcr-dot" style="background:'+(c.couleur||'#888')+'"></div><span>'+(c.nom||id)+'</span></div>';
      }).join('')+'</div>';

    var msg = '<div class="gcr-message"><p>'+(grille.message_intention||'')+'</p></div>';

    var rituel = grille.rituel || {};
    var rituelTitre = state.pourQui === 'autre'
      ? ('\u2736\u00a0 Rituel de transmission \u2014 2 minutes \u00a0\u2736')
      : ('\u2736\u00a0 Rituel d\u2019ancrage \u2014 2 minutes \u00a0\u2736');
    var rituelCard = '<div class="gcr-rituel">'+
      '<div class="gcr-rituel-title">'+rituelTitre+'</div>'+
      '<div class="gcr-rituel-steps">'+
        '<div class="gcr-rituel-step"><div class="gcr-rituel-num">I</div><div class="gcr-rituel-text">'+(rituel.etape1||'')+'</div></div>'+
        '<div class="gcr-rituel-step"><div class="gcr-rituel-num">II</div><div class="gcr-rituel-text">'+(rituel.etape2||'')+'</div></div>'+
        '<div class="gcr-rituel-step"><div class="gcr-rituel-num">III</div><div class="gcr-rituel-text">'+(rituel.etape3||'')+'</div></div>'+
      '</div>'+
      '</div>';

    var accDefs = [
      {key:'centre',       label:'\u2736 La pierre centrale',         text:grille.explication_centre,        poetic:false},
      {key:'cheminement',  label:'\u25c8 Les pierres de cheminement', text:grille.explication_cheminement,   poetic:false},
      {key:'amplification',label:'\u2727 Les amplificateurs',         text:grille.explication_amplification, poetic:false},
      {key:'activation',   label:'\u2295 Activation de la grille',    text:grille.activation,                poetic:true}
    ];
    var accs = accDefs.map(function(def){
      var isOpen = state.accordionOpen[def.key] ? ' open' : '';
      var rot = state.accordionOpen[def.key] ? 'style="transform:rotate(180deg)"' : '';
      return '<div class="gcr-acc">'+
        '<button class="gcr-acc-trigger" data-acc="'+def.key+'">'+
          '<span class="gcr-acc-label">'+def.label+'</span>'+
          '<span class="gcr-acc-arrow" '+rot+'>\u25bc</span>'+
        '</button>'+
        '<div class="gcr-acc-body'+isOpen+'">'+
          '<p class="'+(def.poetic?'gcr-poetic':'')+'">'+(def.text||'')+'</p>'+
        '</div>'+
        '</div>';
    }).join('');

    return strip+gridHTML+chips+msg+rituelCard+
      '<div class="gcr-accordions">'+accs+'</div>'+
      '<div class="gcr-divider">\u2736</div>'+
      '<div class="gcr-cta"><p>Cette grille agit d\u00e8s maintenant dans le plan \u00e9th\u00e9rique sur votre champ \u00e9nerg\u00e9tique. Si vous poss\u00e9dez certaines de ces pierres physiquement, disposez-les selon cette g\u00e9om\u00e9trie pour amplifier l\u2019effet dans votre espace.</p></div>'+
      '<div class="gcr-cta" style="margin-top:.75rem"><p>Souhaitez-vous approfondir votre pratique en lith\u00e9rapie et en g\u00e9om\u00e9trie sacr\u00e9e\u00a0?</p><a href="https://www.unlieudelumiere.com/collections/all">D\u00e9couvrir mes formations</a></div>'+
      '<div class="gcr-notice">\u2736 Votre grille du jour est unique. Une nouvelle composition vous attend demain.</div>'+
      '<div class="gcr-reset-row">'+
        '<button class="gcr-btn gcr-btn-ghost" id="gcr-reset">Recommencer avec une nouvelle intention</button>'+
        '<button class="gcr-btn gcr-btn-ghost" id="gcr-print">\u2399 Imprimer la grille</button>'+
      '</div>';
  }

  /* ======================== EVENTS ======================== */

  function bindEvents() {
    shadow.querySelectorAll('.gcr-tile').forEach(function(tile) {
      tile.addEventListener('click', function() {
        var id = tile.dataset.intention;
        state.intention = INTENTIONS.filter(function(i){return i.id===id;})[0]||null;
        state.step = 2; state.error = null;
        renderView(); scrollToTool();
      });
    });

    var backBtn = shadow.querySelector('#gcr-back');
    if (backBtn) backBtn.addEventListener('click', function() { state.step=1; renderView(); scrollToTool(); });

    shadow.querySelectorAll('.gcr-toggle').forEach(function(btn) {
      btn.addEventListener('click', function() {
        state.pourQui = btn.dataset.pq;
        renderView(); scrollToTool();
      });
    });

    var nomInput = shadow.querySelector('#gcr-nom');
    if (nomInput) nomInput.addEventListener('input', function() { state.nomDestinataire = nomInput.value; });

    var genBtn = shadow.querySelector('#gcr-generate');
    if (genBtn) genBtn.addEventListener('click', function() {
      var dobInput = shadow.querySelector('#gcr-dob');
      var nomEl = shadow.querySelector('#gcr-nom');
      var dob = dobInput ? dobInput.value : '';
      if (!dob) { state.error='Veuillez entrer la date de naissance.'; renderView(); return; }
      if (nomEl) state.nomDestinataire = nomEl.value;
      var parts = dob.split('-');
      state.dob = dob;
      state.signe = getSigneAstro(parseInt(parts[2],10), parseInt(parts[1],10));
      state.cheminVie = getCheminVie(parseInt(parts[2],10), parseInt(parts[1],10), parseInt(parts[0],10));
      state.step = 3;
      generateGrille();
    });

    var resetBtn = shadow.querySelector('#gcr-reset');
    if (resetBtn) resetBtn.addEventListener('click', function() {
      try { localStorage.removeItem(STORAGE_KEY); } catch(e) {}
      state.step=1; state.intention=null; state.dob=null; state.signe=null;
      state.cheminVie=null; state.grille=null; state.error=null; state.accordionOpen={};
      state.pourQui='moi'; state.nomDestinataire='';
      renderView(); scrollToTool();
    });

    var printBtn = shadow.querySelector('#gcr-print');
    if (printBtn) printBtn.addEventListener('click', printGrille);

    shadow.querySelectorAll('.gcr-acc-trigger').forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var key = trigger.dataset.acc;
        state.accordionOpen[key] = !state.accordionOpen[key];
        var body = trigger.nextElementSibling;
        if (body) body.classList.toggle('open', !!state.accordionOpen[key]);
        var arrow = trigger.querySelector('.gcr-acc-arrow');
        if (arrow) arrow.style.transform = state.accordionOpen[key] ? 'rotate(180deg)' : '';
      });
    });
  }

  /* ======================== START ======================== */
  renderView();
  if (state.step === 4) scrollToTool();

})();